import { create } from 'zustand';

/** One feedback dialog for the whole app, opened from Settings › About and from the corner button. */
export const useFeedback = create<{ open: boolean; setOpen: (open: boolean) => void }>((set) => ({ open: false, setOpen: (open) => set({ open }) }));
